import type { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  useEnrollScaEnrollment,
  useGetServiceProviderPhoenixNoSuspense,
} from '@pflegenavi/service-provider-frontend/api';
import { ScaEnrollmentButton as SharedScaEnrollmentButton } from '@pflegenavi/web-components';

export const ScaEnrollmentButton: FC = () => {
  const { data: serviceProvider, refetch } =
    useGetServiceProviderPhoenixNoSuspense();

  const { mutateAsync: enrollScaEnrollment } = useEnrollScaEnrollment();
  const [searchParams] = useSearchParams();
  const controlStatus = searchParams.get('controlStatus');

  const isEnrolled = serviceProvider?.data?.mangopay_sca_enrolled ?? false;
  const hasData = !!serviceProvider?.data;

  // Show button if not enrolled, OR if enrollment process is active
  const showScaEnrollmentButton =
    hasData && (!isEnrolled || controlStatus !== null);

  if (!showScaEnrollmentButton) {
    return null;
  }

  return (
    <SharedScaEnrollmentButton
      isEnrolled={isEnrolled}
      onEnroll={() => enrollScaEnrollment(window.location.href)}
      refetch={refetch}
      showCloseButton={true}
    />
  );
};
